<template>
    <div>
        页面飞走了...
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>